import React from "react"

const COLORS = {
  subscription: "bg-indigo-500",
  usage: "bg-sky-400",
  one_time: "bg-amber-500",
  service: "bg-emerald-500",
}
const DOT = {
  subscription: "bg-indigo-500",
  usage: "bg-sky-400",
  one_time: "bg-amber-500",
  service: "bg-emerald-500",
}

// Revenue-by-type: a single stacked bar (predictability of the revenue base)
// with a labelled legend underneath. `mix` is [{kind, pct}], summing to 100.
export function RevenueMix({ mix, labels, emptyLabel }) {
  if (!mix || mix.length === 0) return <p className="text-sm text-gray-500 dark:text-gray-400">{emptyLabel}</p>

  return (
    <div>
      <div className="flex h-2.5 overflow-hidden rounded-full bg-gray-100 dark:bg-gray-800">
        {mix.map((m) => (
          <div key={m.kind} className={COLORS[m.kind] || "bg-gray-400 dark:bg-gray-600"} style={{ width: `${m.pct}%` }} />
        ))}
      </div>
      <ul className="mt-4 grid grid-cols-2 gap-2">
        {mix.map((m) => (
          <li key={m.kind} className="flex items-center justify-between text-sm">
            <span className="flex items-center gap-2">
              <span className={`h-2 w-2 rounded-full ${DOT[m.kind] || "bg-gray-400 dark:bg-gray-600"}`} />
              <span className="text-gray-600 dark:text-gray-400">{labels[m.kind] || m.kind}</span>
            </span>
            <span className="font-medium text-gray-700 dark:text-gray-300">{m.pct}%</span>
          </li>
        ))}
      </ul>
    </div>
  )
}
